import { useState } from "react"
import { useAuthContext } from "./useAuthContext"
import { useNavigate } from "react-router-dom"

export const useSignUp =  () => {
    const [isLoading, setIsLoading] = useState(null)
    const [error, setError] = useState(null)
    const { dispatch } = useAuthContext()
    const navigate = useNavigate()

    const signup = async(name, email, password) => {
        setIsLoading(true)
        setError(null)
        const response =await fetch('https://myrestaurantmz3699-junaidedmehroz3699.b4a.run/api/user/signup', {
            method: 'POST',
            headers : {'Content-Type': 'application/json'},
            body : JSON.stringify({name, email, password})
        })
        const json = await response.json()
        
        console.log(response);

        if(!response.ok) {
            setIsLoading(false)
            setError(json.error)
        }

        if(response.ok) {
            //save user to localStorage
            localStorage.setItem('user', JSON.stringify(json))

            //update AuthContext
            dispatch({ type : 'LOGIN', payload : json})

            setIsLoading(false)
            navigate('/')
        }
    }
    return { signup, isLoading, error}
}

export default useSignUp